import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TenantService, UtilService } from '../services';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment-timezone';
import { takeUntil, filter, flatMap } from 'rxjs/operators';
import { ConfirmationDialogComponent } from '../general/confirmationDialog.component';
import { MatDialog } from '@angular/material/dialog';
import { HasChanges } from '../services/HasChanges';
import * as _ from 'lodash';

@Component({
    template: `
    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around" style="padding-left: 15px; padding-right: 15px;">
        <div *ngIf="noTouching" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner></spinner>
        </div>
        <mat-card *ngIf="!noTouching" fxFlex fxLayout="column" fxLayoutAlign="space-around start">
            <mat-card-header>
                <mat-card-title><h2>Account Settings</h2></mat-card-title>
            </mat-card-header>
            <mat-card-content fxFlex="100" fxLayout="column" style="width:100%;" [formGroup]="form">
                <div> 
                    <mat-form-field>
                        <input matInput placeholder="Account Name" formControlName="name">
                    </mat-form-field>
                    <mat-form-field style="padding-left: 25px;">
                        <input matInput placeholder="Host Name" formControlName="hostName">
                    </mat-form-field>
                </div>
                <mat-form-field>
                    <input matInput type="text" placeholder="Logo Url" formControlName="logoUrl" maxlength="256">
                    <mat-error *ngIf="form.get('logoUrl')?.hasError('pattern')">Logo Url must be valid.</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input matInput type="text" placeholder="Favicon Url" formControlName="faviconUrl" maxlength="256">
                    <mat-error *ngIf="form.get('faviconUrl')?.hasError('pattern')">Favicon Url must be valid.</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Application Title" formControlName="title">
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="New User Added Notification Address" formControlName="newUserNotification">
                    <mat-error *ngIf="form.get('newUserNotification')?.hasError('pattern')">Email address must be valid.</mat-error>
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="!noTouching" fxFlex="90" fxLayout="column" fxLayoutAlign="space-around start">
            <mat-card-header>
                <mat-card-title><h2>Briefing Settings</h2></mat-card-title>
            </mat-card-header>
            <mat-card-content fxFlex="100" fxLayout="column" style="width:100%;">
                <ng-container [formGroup]="form">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Briefings From Address" formControlName="briefingsFromAddress" maxlength="256">
                        <mat-error *ngIf="form.get('briefingsFromAddress').hasError('required')">Briefings From Address is required.</mat-error>
                        <mat-error *ngIf="form.get('briefingsFromAddress')?.hasError('pattern')">Briefings From Address must be valid.</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="text" placeholder="Briefings Reply To Address" formControlName="briefingsReplyToAddress" maxlength="256">
                        <mat-error *ngIf="form.get('briefingsReplyToAddress').hasError('required')">Briefings Reply To Address is required.</mat-error>
                        <mat-error *ngIf="form.get('briefingsReplyToAddress')?.hasError('pattern')">Briefings Reply To Address must be valid.</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="text" placeholder="Default Title" formControlName="defaultTitle" maxlength="256">
                        <mat-error *ngIf="form.get('defaultTitle').hasError('required')">Default Title is required.</mat-error>
                    </mat-form-field>
                    <div fxLayout="row"><h3>Default Schedule</h3></div>
                    <div fxLayout="row">
                        <mat-checkbox formControlName="defaultDigestScheduleActive">
                            Use Default Schedule for new users
                        </mat-checkbox>
                        </div>
                    <div *ngIf="form.get('defaultDigestScheduleActive').value" formGroupName="defaultDigestSchedule">
                        <div fxLayout="row" class="item-row">
                            <mat-form-field fxFlexOffset="10"  fxFlex="80">
                                <mat-select placeholder="Frequency" formControlName="freq">
                                    <mat-option *ngFor="let freq of frequencies" [value]="freq.value">{{ freq.viewValue }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" *ngIf="form?.get('defaultDigestSchedule')?.get('freq')?.value === 'WEEKLY'" class="item-row">
                            <div fxLayout="column" fxFlexOffset="10">
                                <span class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Day </span>
                                <div fxLayout="row">
                                    <mat-button-toggle-group formControlName="sendDay" multiple>
                                        <mat-button-toggle value="SU">S</mat-button-toggle>
                                        <mat-button-toggle value="MO">M</mat-button-toggle>
                                        <mat-button-toggle value="TU">T</mat-button-toggle>
                                        <mat-button-toggle value="WE">W</mat-button-toggle>
                                        <mat-button-toggle value="TH">T</mat-button-toggle>
                                        <mat-button-toggle value="FR">F</mat-button-toggle>
                                        <mat-button-toggle value="SA">S</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <mat-form-field fxFlexOffset="10" fxFlex="80">
                                <mat-select placeholder="Timezone" formControlName="timeZone">
                                    <mat-option *ngFor="let zone of timezones" [value]="zone.value">{{ zone.viewValue }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" style="padding-top:20px;">
                                <div fxFlexOffset="10" class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Time </div>
                                <time-picker fxFlexOffset="10" formControlName="sendTime"></time-picker>
                        </div>
                    </div>
                </ng-container>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="!noTouching" fxFlex="90" fxLayout="column" fxLayoutAlign="space-around start">
            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="save()" [disabled]="form.pristine || form.invalid || form.disabled">Save</button>
            </mat-card-actions>
        </mat-card>
    </div>
`
})
export class AccountComponent implements OnDestroy, HasChanges {
    private cleanupTime = new Subject<void>();
    frequencies = this.utilService.digestFrequencies;
    timezones = this.utilService.displayTimezones;
    
    readonly emailPattern = '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$'; 
    readonly urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    noTouching = true;
    form: FormGroup;
    readonly settingConfigs = [
        { key: 'name', isDisabled: true },
        { key: 'hostName', isDisabled: true },
        { key: 'publicTopics', isSettings: true, isBoolean: true },
        { key: 'briefingsFromAddress', isSettings: true, validators: [Validators.required, Validators.pattern(this.emailPattern)] },
        { key: 'briefingsReplyToAddress', isSettings: true, validators: [Validators.required, Validators.pattern(this.emailPattern)] },
        { key: 'defaultTitle', isSettings: true, valdidators: [Validators.required] },
        { key: 'logoUrl', isSettings: true, validators: [Validators.pattern(this.urlPattern)] }, 
        { key: 'faviconUrl', isSettings: true, validators: [Validators.pattern(this.urlPattern)] }, 
        { key: 'title', isSettings: true }, 
        { key: 'newUserNotification', isSettings: true, validators: [Validators.pattern(this.emailPattern)] }
    ];
    tenant: any;
    originalValue: any;

    constructor(fb: FormBuilder, 
                private utilService: UtilService, 
                public snackBar: MatSnackBar,
                private dialog: MatDialog, 
                private tenantService: TenantService) {
        tenantService.getCurrentTenant().subscribe(tenant => {
            this.tenant = tenant;

            let sendTime = moment().startOf('hour');
            if (tenant.settings.defaultDigestSchedule) {
                if (tenant.settings.defaultDigestSchedule.sendHour) {
                    sendTime = moment().set('hour', tenant.settings.defaultDigestSchedule.sendHour);
                }
                if (tenant.settings.defaultDigestSchedule.sendMinute) {
                    if (!sendTime) {
                        sendTime = moment().startOf('day');
                    }
                    sendTime = moment().set('minute', tenant.settings.defaultDigestSchedule.sendMinute);
                }
            }
            const defaultTimezone = this.utilService.zoneMap[moment.tz.guess()] || moment.tz.guess();
            this.form = fb.group(this.settingConfigs.reduce((accum, settingConfig) => {
                let val; 
                if (settingConfig.isSettings) {
                    val = settingConfig.isBoolean ? tenant.settings[settingConfig.key] === 'true' : tenant.settings[settingConfig.key];
                } else {
                    val = tenant[settingConfig.key];
                } 
                
                accum[settingConfig.key] = [{value: val, disabled: settingConfig.isDisabled}, settingConfig.validators || []];
                return accum;
            }, {
                defaultDigestScheduleActive: [!!tenant.settings.defaultDigestSchedule],
                defaultDigestSchedule: fb.group({
                    timeZone: [tenant.settings.defaultDigestSchedule ? tenant.settings.defaultDigestSchedule.timeZone : defaultTimezone],
                    sendDay: [tenant.settings.defaultDigestSchedule && tenant.settings.defaultDigestSchedule.sendDay ? tenant.settings.defaultDigestSchedule.sendDay : ['MO']],
                    freq: [tenant.settings.defaultDigestSchedule ? tenant.settings.defaultDigestSchedule.freq : 'DAILY'],
                    interval: [tenant.settings.defaultDigestSchedule ? tenant.settings.defaultDigestSchedule.interval : 1],
                    sendTime: [sendTime] 
                })
            }));
            this.originalValue = _.cloneDeep(this.form.value)

            this.form.get('publicTopics').valueChanges
            .pipe(
                filter(isPublic => isPublic),
                flatMap(() => this.dialog.open(ConfirmationDialogComponent, { 
                    data: {
                        title: `Making the Discover page public will expose all of your published Topics to the internet. Continue?`, 
                        actionLabel: 'Continue'}
                    }).afterClosed()),
                filter(doIt => !doIt),
                takeUntil(this.cleanupTime)
            ).subscribe(() => this.form.get('publicTopics').setValue(false, { notify: false }));


            this.noTouching = false;
        });
    }

    save() {
        this.settingConfigs.forEach(settingConfig => {
            if (!settingConfig.isDisabled && settingConfig.isSettings) {
                if (settingConfig.isBoolean) {
                    this.tenant.settings[settingConfig.key] = this.form.value[settingConfig.key] === 'false' ? undefined : this.form.value[settingConfig.key];
                } else {
                    this.tenant.settings[settingConfig.key] = this.form.value[settingConfig.key];
                }
            }
        });
        
        if (this.form.get('defaultDigestScheduleActive').value) {
            const defaultDigestSchedule = this.form.get('defaultDigestSchedule');
            const sendTime = moment(defaultDigestSchedule.get('sendTime').value);
            this.tenant.settings.defaultDigestSchedule = {
                timeZone: defaultDigestSchedule.get('timeZone').value,
                freq: defaultDigestSchedule.get('freq').value,
                sendDay: defaultDigestSchedule.get('freq').value === 'WEEKLY' ? defaultDigestSchedule.get('sendDay').value : undefined,
                interval: defaultDigestSchedule.get('interval').value,
                sendHour: sendTime.get('hour'),
                sendMinute: sendTime.get('minute')
            };
        } else {
            this.tenant.settings.defaultDigestSchedule = undefined;
        }

        this.tenantService.saveSettings(this.tenant.settings)
        .subscribe(
            () => {
                this.saveFinish('Account Settings updated.');
                this.originalValue = _.cloneDeep(this.form.value);
            },
            (err) => {
                console.log(err);
                this.saveFinish('Unable to update settings.');
            }
        );
    }

    saveFinish(message) {
        ['name', 'hostName'].forEach(key => this.form.get(key).disable());
        this.snackBar.open(message, 'OK', { duration: 3000});
    }

    hasChanges(): boolean {
        return !_.isEqual(this.form.value, this.originalValue);
    }
    existingChangesMessage(): string {
        return 'Continue and lose changes?';
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}